import { Typography } from '@mui/material';
import Button from '../Button';
import { FlexColumn } from '../Flex';
import { REMOVE_CHANGEPOINT_BUTTON_LABEL } from './constants';

type Props = {
  label: string;
  onRemoveClick?: () => void;
};

const ChangepointTooltipSection = ({ label, onRemoveClick }: Props) => (
  <FlexColumn sx={{ gap: 1, mt: 1, maxWidth: 320, alignItems: 'flex-start' }}>
    <Typography variant="body2" color="inherit">
      {label}
    </Typography>
    {onRemoveClick && (
      <Button
        size="extraSmall"
        variant="outlined"
        color="secondary"
        onClick={onRemoveClick}
      >
        {REMOVE_CHANGEPOINT_BUTTON_LABEL}
      </Button>
    )}
  </FlexColumn>
);

export default ChangepointTooltipSection;
